module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAALCAYAAABPhbxiAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAEMSURBVHgBlVExTgNBDLS9+4D7AfeE4wecCAUVaRCk4yIo6OAFiG+AxOkqpIiCGgRKfnD8YPnBNUhI3NrYq0iEpEgy1dprj2dshDnuH1/3vKcjFsgRsIA/dIDQIUgbWWbnJ4NnS6I1OOdqfeewGQILX9OWTYackGoC5BlsC5aGxseDM4lSqY/pmnLzOo0xluPT/Susn97q/oebi9FBarybvBQYMSOgPJEDhx76cDk6DBannXh3gw+Td5kzBtHNgcCHVod/s0h9OdgRxqFGmaX8wredIVc5Q3CrOoVhiQuW2DdDIPVTqrwmmV+PTkRu8Qt3cTFrxvVGhcrNzJPlOMKnEnd69NZ/+7aqyjTgF39CZqE1c6nkAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/scenes/LandingPage/images/new/database.png
// module id = 3213
// module chunks = 0